// @flow

import $ from 'jquery';
import { retrieve } from 'putki';
import getCookies from 'utils/getCookies';
import { trackEvent, trackClicksOn } from 'utils/analytics';

import { retrieveRemarketingProperties } from './analytics/remarketing';

/**
 * Rebinds tracking of anchor elements with data-venuu-t attributes.
 */
function rebindTrackedLinks() {
  trackClicksOn($('a[data-venuu-t]:not([data-venuu-t-react])'));
}

/**
 * Sends an "Arrived from Campaign" tracking event, if visitor arrived from
 * a Venuu campaign site.
 */
function trackReferringCampaigns() {
  type CampaignDataObject = {
    'Campaign Source': string,
    'Campaign Name': string,
    'Campaign Medium'?: string,
    ...
  };

  const campaignDataFromUrl: string => null | CampaignDataObject = urlParam => {
    let url;
    try {
      // URLs which purl can't parse might throw. Don't throw in that case.
      // See https://github.com/venuu/venuu/issues/749
      url = $.url(urlParam);
    } catch (e) {
      return null;
    }

    const soundboard = url.attr('host').match(/(cheek|putous)\.venuu.fi/i);
    if (soundboard) {
      // Real result should be in the second cell of Array returned by match,
      // but browsers might differ on whether they return the full match as the
      // first cell or not. Work around that pre-emptively.
      const campaignName =
        soundboard.length === 2 ? soundboard[1] : soundboard[0];
      return {
        'Campaign Source': 'Soundboard',
        'Campaign Name': campaignName.toLowerCase()
      };
    } else {
      return null;
    }
  };

  const campaignData = campaignDataFromUrl(window.document.referrer);
  if (campaignData) {
    campaignData['Campaign Medium'] = 'Referral';
    window.analytics.identify(campaignData);
    trackEvent('Arrived from Campaign', campaignData);
  }
}

export default function initializeAnalytics() {
  const traits = {
    'Application Version': retrieve('application_version')
  };
  const options = {
    anonymousId: getCookies()['cheekify_a']
  };

  const userID = getCookies()['cheekify_u'];
  if (userID) {
    window.analytics.identify(userID, traits, options);
  } else {
    window.analytics.identify(traits, options);
    // Wait for analytics scripts to load before accessing window.mixpanel
    // https://github.com/venuu/venuu/issues/2870
    window.analytics.ready(() => {
      // Mixpanel has already assigned a distinct_id on its own and we need to
      // override it. Plain analytics.identify() call doesn't get applied to it.
      if (window.mixpanel) {
        window.mixpanel.identify(options.anonymousId);
      }
    });
  }

  const pageOpts = retrieveRemarketingProperties();

  window.analytics.page(pageOpts);

  // Track special links
  rebindTrackedLinks();

  trackReferringCampaigns();
}
